import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import i18n from '../i18n/i18n';

export default function HomeView() {
	const { t } = useTranslation();
	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
	}
	return (
		<div>
			<h2>{t('home.welcome')} </h2>
			<div className='additional_texts'>
				{
					t('home.subline').split('\n').map((item, key) => {
						return <div><span key={key}>{item}<br /></span></div>
					})
				}

			</div>
		</div>
	)
}